<template>
    <div v-if="homeOffer1 && homeOffer1.length">
      <VueSlickCarousel v-bind="settings">
        <div
          id="carousel-home"
          class="containers-image text-center"
          v-for="(image, index) in homeOffer1"
          :key="index"
        >
          <img class="image" :src="image.url.fileUrl" />
        </div>
      </VueSlickCarousel>
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  import VueSlickCarousel from "vue-slick-carousel";
  import "vue-slick-carousel/dist/vue-slick-carousel.css";
  import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
  
  export default {
    name: "home-offer",
    components: { VueSlickCarousel },
    data() {
      return {
        settings: {
          arrows: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: 4,
          touchMove: true,
        },
      };
    },
    computed: {
      ...mapState({
        homeOffer1: ({ advertisement }) => advertisement.homeOffer1,
      }),
    },
    methods: {
      ...mapActions({
        fetchhomeScreenOffer1Data: "advertisement/homeScreenOffer1",
      }),
    },
  
    mounted() {
      this.fetchhomeScreenOffer1Data();
    },
  };
  </script>
  
  <style scoped>
  .containers-image {
    display: block;
    width: 50%;
    place-items: center;
  }
  .image {
    border-radius: 10px;
    height: 200px;
    width: 250px;
  }
  </style>
  